import React, { useState, useEffect, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Header from '../../../Header/Header';
import Spinner from '../../../Spinner/Spinner';
import PPQuizTaker from '../PPQuizTaker/PPQuizTaker';
import loaderColors1 from '../../../Spinner/loaderColors1.gif';
import { withAuth, handleResponse, handleJwtTokenForKeppMeLoggedIn } from "../../../../app/util/HOC";
export function PPGradedQuiz() {
    const history = useHistory();
    const isLandingPageInfor = useRef(false);
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const { isbn, subtopictagid, subjectareatagid, videoType } = useParams();
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const authToken = userVO.apJwtAuthenticationToken ? userVO.apJwtAuthenticationToken : localStorage.getItem('apJwtAuthenticationToken');
    const quizVO = (videoType !== 'video' ?
        JSON.parse(localStorage.getItem('quCeGraModeQuizData')) :
        {
            "isGraded": true, "quizType": "video", "subTopicTagId": [subtopictagid],
            "quizTiming": 300, "totalQuestions": ""
        }
    );
    const [videoPPQuiz, setVideoPPQuiz] = useState('');
    const [otherPPQuiz, setOtherPPQuiz] = useState('');
    const [isGraQuizLoad, setIsGraQuizLoad] = useState(true);
    const [ppQuizResultVO, setPpQuizResultVO] = useState(videoType !== 'video' ? quizVO.instanceId === undefined ? '' : quizVO : '');
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken
        }
    }
    const getPostPPQuizInstance = async () => {
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "keepMeLoggedInFlag": keepMeLogIn,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "quizVO": quizVO,
            "ppSubjectAreaTagId": subjectareatagid
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
        };
        fetch(`${localStorage.getItem('qpAPI')}/PP/postPPQuizInstance`, requestOptions)
            .then(handleResponse)
            .then(response => response.json())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then((data) => {
                setPpQuizResultVO(data.PpQuizResultVO);
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const getVideoPPQuiz = async () => {
        if (videoType !== 'video') {
            var ppSubtopicVoList = [], subTopicTagIdList;
            if (quizVO.subTopicTagId) {
                subTopicTagIdList = Array.isArray(quizVO.subTopicTagId) ? quizVO.subTopicTagId : (quizVO.subTopicTagId).split(",");
                subTopicTagIdList.map(topicTagId => { ppSubtopicVoList.push({ "subTopictagId": topicTagId }); });
            }
            let reqData = {
                "userVO": {
                    "userId": userVO.userId,
                    "userRole": userVO.userRole,
                    "schoolId": userVO.schoolId,
                    "userRoleId": userVO.userRoleId,
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "userActivityVO": {
                        "lastReadBookId": "",
                        "lastReadPageNum": "",
                        "lastReadChapterId": "",
                        "lastReadSectionId": "",
                        "lastReadParagraphId": "",
                        "lastViewedOutlineId": "",
                        "lastReadSubSectionId": "",
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingFrom": "EReader",
                        "pageNavigatingTo": "Bookshelf",
                    },
                    "sessionVO": getSessionVO()
                },
                "quizDetails": {
                    "type": quizVO.quizType,
                    "isGraded": quizVO.isGraded,
                    "quiztime": quizVO.quizTiming,
                    "instanceId": ppQuizResultVO.instanceId,
                    "questionscount": quizVO.totalQuestions,
                    "identifier": ppQuizResultVO.quizIdentifier,
                },
                "ppsubject": { "ppsubTopicVoList": ppSubtopicVoList }
            };
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify(reqData),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
            };
            fetch(`${localStorage.getItem('qpAPI')}/PP/getPPBuildQuizs/${ppQuizResultVO.instanceId}`, requestOptions)
                .then(handleResponse)
                .then(response => response.json())
                .then(handleJwtTokenForKeppMeLoggedIn)
                .then((data) => {
                    setOtherPPQuiz(data);
                    setIsGraQuizLoad(false);
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                });
        } else {
            let reqData = {
                "userVO": {
                    "userId": userVO.userId,
                    "userRole": userVO.userRole,
                    "schoolId": userVO.schoolId,
                    "userRoleId": userVO.userRoleId,
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "userActivityVO": {
                        "lastReadBookId": "",
                        "lastReadPageNum": "",
                        "lastReadChapterId": "",
                        "lastReadSectionId": "",
                        "lastReadParagraphId": "",
                        "lastViewedOutlineId": "",
                        "lastReadSubSectionId": "",
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingFrom": "EReader",
                        "pageNavigatingTo": "Bookshelf",
                    },
                    "sessionVO": getSessionVO()
                },
                "quizDetails": {
                    "type": "Video",
                    "isGraded": ppQuizResultVO.isGraded,
                    "instanceId": ppQuizResultVO.instanceId
                },
                "associatedMetadataMappings": { "identifier": subtopictagid }
            };
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify(reqData),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
            };
            fetch(`${localStorage.getItem('qpAPI')}/PP/getVideoPPQuiz/${subtopictagid}`, requestOptions)
                .then(handleResponse)
                .then(response => response.json())
                .then(handleJwtTokenForKeppMeLoggedIn)
                .then((data) => {
                    setVideoPPQuiz(data);
                    setIsGraQuizLoad(false);
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                });
        }
    }
    useEffect(() => {
        if (videoType !== 'video') {
            if (quizVO.instanceId === undefined) {
                getPostPPQuizInstance();
            } else {
                getVideoPPQuiz();
            }
        } else {
            if (
                localStorage.getItem('ppQuizInstances') === null ||
                localStorage.getItem('ppQuizInstances') === "undefined" ||
                localStorage.getItem('ppQuizInstances') === undefined
            ) {
                getPostPPQuizInstance();
            } else {
                var ppQuizInstances = JSON.parse(localStorage.getItem('ppQuizInstances'));
                if ((ppQuizInstances.instanceId === undefined && ppQuizInstances.incompleteQuizInstanceId === undefined)) {
                    getPostPPQuizInstance();
                } else {
                    if (ppQuizInstances.isGraded === undefined) {
                        ppQuizInstances.isGraded = true;
                    }
                    if (ppQuizInstances.quizType === undefined) {
                        ppQuizInstances.quizType = "video";
                    }
                    ppQuizInstances.instanceId = ppQuizInstances.incompleteQuizInstanceId !== undefined ?
                        ppQuizInstances.incompleteQuizInstanceId : ppQuizInstances.instanceId;
                    setPpQuizResultVO(ppQuizInstances);
                }
            }
        }
    }, []);
    useEffect(() => {
        if (isLandingPageInfor.current) {
            if (history.action === "POP") {
                history.push(`/pp-video-library/${isbn}`);
            } else {
                getVideoPPQuiz();
            }
        } else {
            if (history.action === "POP") {
                history.push(`/pp-video-library/${isbn}`);
            } else {
                isLandingPageInfor.current = true;
            }
        }
    }, [ppQuizResultVO]);
    return (
        <>
            <Spinner
                loading={isGraQuizLoad}
                imageSrc={loaderColors1}
                overlayBackground="rgba(0,0,0,0.5)"
            />
            <Header userVO={userVO} pageName="CCPracticePerfect" isbn={isbn}></Header>
            <div>
                <div className="ppQuizNotifiContainer">
                    <div style={{ textAlign: "center" }} className="display-inline-block ppQuizNotifiTxt col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        PracticePerfect content is for personal use only. Redistribution is strictly prohibited. &copy; Aspen Publishing
                    </div>
                </div>
            </div>
            {
                videoType !== 'video' ?
                    (otherPPQuiz) ? <PPQuizTaker ppQuizResultVO={ppQuizResultVO} videoPPQuiz={otherPPQuiz} /> : null :
                    (videoPPQuiz) ? <PPQuizTaker ppQuizResultVO={ppQuizResultVO} videoPPQuiz={videoPPQuiz} /> : null
            }
        </>
    )
}
export default withAuth(PPGradedQuiz);